import { render, staticRenderFns } from "./Recal.vue?vue&type=template&id=7385cbca&scoped=true&"
import script from "./Recal.vue?vue&type=script&lang=ts&"
export * from "./Recal.vue?vue&type=script&lang=ts&"
import style0 from "./Recal.vue?vue&type=style&index=0&id=7385cbca&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7385cbca",
  null
  
)

export default component.exports